export const BIG_BANNER_ID = 'page_top';

export const BIG_BANNER_MOBILE_ID = 'page_mtopline';

export const BANNER_SMALL_LOT_INSIDE = 'page_nmr';

export const REAL_ESTATE_BANNER = 'page_nmr2';
